export type InvoiceStatus = 'open' | 'partial' | 'paid';

export interface InvoiceStatusInput {
  totalInclBtw: number;
  openAmount: number;
  transactionTotal: number;
  paid?: boolean;
}

/**
 * Drietrapstatus volgens kantoor-bedrijfsregel (zie AI-BUSINESS-RULES.md):
 * - Voldaan: factuur volledig voldaan (SF-flag) of openAmount ≈ 0
 * - Deelbetaling: er is al iets binnen, maar niet het volle bedrag
 * - Openstaand: er is niets binnen
 */
export function computeInvoiceStatus(i: InvoiceStatusInput): InvoiceStatus {
  if (i.paid || i.openAmount <= 0.01) return 'paid';
  if (i.transactionTotal > 0.01) return 'partial';
  return 'open';
}

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  open: 'Openstaand',
  partial: 'Deelbetaling',
  paid: 'Voldaan',
};

export const INVOICE_STATUS_COLORS: Record<InvoiceStatus, string> = {
  open: 'bg-amber-100 text-amber-700',
  partial: 'bg-blue-100 text-blue-700',
  paid: 'bg-emerald-100 text-emerald-700',
};

/**
 * Fase-badges van de vervallen/incasso-scope. Herinnering-fases zijn
 * cadence-afgeleid (vervaldatum + 7/15), geen bewezen aflevering: de
 * SF-flow laat geen verzendspoor na. "Op factuur" = B2B factuur-achteraf,
 * krijgt geen herinneringen en dus ook geen automatische incasso-trede.
 */
export type IncassoFaseBadge =
  | 'vervallen'
  | 'herinnering1'
  | 'aanmaning'
  | 'op-factuur'
  | 'kandidaat'
  | 'uitgesloten'
  | 'bij-incasso'
  | 'betaald'
  | 'oninbaar'
  | 'afgeboekt';

export const INCASSO_FASE_LABELS: Record<IncassoFaseBadge, string> = {
  vervallen: 'Vervallen',
  herinnering1: 'Herinnering 1',
  aanmaning: 'Aanmaning',
  'op-factuur': 'Op factuur',
  kandidaat: 'Incasso-kandidaat',
  uitgesloten: 'Uitgesloten',
  'bij-incasso': 'Bij incasso',
  betaald: 'Betaald',
  oninbaar: 'Oninbaar',
  afgeboekt: 'Afgeboekt',
};

export const INCASSO_FASE_COLORS: Record<IncassoFaseBadge, string> = {
  vervallen: 'bg-slate-100 text-slate-600',
  herinnering1: 'bg-amber-100 text-amber-700',
  aanmaning: 'bg-orange-100 text-orange-700',
  'op-factuur': 'bg-blue-100 text-blue-700',
  kandidaat: 'bg-red-100 text-red-700',
  uitgesloten: 'bg-slate-200 text-slate-600',
  'bij-incasso': 'bg-red-600 text-white',
  betaald: 'bg-emerald-100 text-emerald-700',
  oninbaar: 'bg-slate-700 text-white',
  afgeboekt: 'bg-slate-200 text-slate-600',
};
